import { Box } from "@material-ui/core";
import React from "react";
import ProjectFormWrapper from "../../components/Project/ProjectFormWrapper/ProjectFormWrapper";
import Page from "../Page/Page";
import useStyles from "./styles";

const ProjectNewPage: React.FC = () => {
    const classes = useStyles();

    return (
        <Page noProjects noOverflow>
            <Box className={classes.box}>
                <ProjectFormWrapper />
            </Box>
        </Page>
    );
};

export default ProjectNewPage;
